import React from "react";

const Quote = ({ quote, motorcycle }: any) => {
  return (
    <div
      style={{
        textAlign: "left",
        marginTop: "40px",
      }}
    >
      <p
        style={{
          color: "#36424a",
          fontSize: "1rem",
          fontFamily: "sans-serif",
        }}
      >
        MY BLUEBOOK VALUATION*
      </p>
      <p
        style={{
          color: "#36424a",
          fontSize: "30px",
          fontFamily: "sans-serif",
          fontWeight: 400,
        }}
      >
        {quote && `${quote}`}
        {!quote && motorcycle.make && "$-"}
        {!quote && !motorcycle.make && 0}
      </p>
      <p
        style={{
          color: "#36424a",
          fontFamily: "sans-serif",
          fontWeight: 400,
        }}
      >
        *Based On Assumed Condition Of *Clean*.
      </p>
    </div>
  );
};

export default Quote;
